<template>
  <div class="overflow-hidden"  >
    <a-spin :spinning="spinnings" tip="資料載中..."> 
    <div class="d-flex flex-column min-vh-100">
      <div class="lineHeader">
        <b-alert
          v-model="showTop"
          class="position-fixed fixed-top m-0 rounded-0"
          style="z-index: 2000;"
          variant="danger"
          dismissible
        >          
          <span v-text="message" />
        </b-alert>        
        <a-button type="link" @click="toNext()" class="fontstyle">
          <b-icon  style="margin-right: 0.3rem;" scale="1.1" icon="chevron-left" variant="light" />
          回上一頁
        </a-button>        
      </div>   
               
        <Inforact v-if="objs!==null" :obj="objs" @loadings="loadings"  ref="con1" />               
      <div class="linefooter">
        <Bottommenu v-if="objs!==null" @openshare="openshare" @showmessage="showmessage" :obj="objs"  />
      </div>
    </div>
    <b-modal ref="my-loading" id="modal-1" title="分享資訊" @hide="onHide" centered hide-footer>
      <Shareurl :obj="objs"  />
    </b-modal>
  </a-spin>
  </div>
</template>

<script>
import { macService } from '../_services'
import * as moment from "moment/moment";
import Inforact from '@/myline/apply/Inforact.vue'
import Bottommenu from '@/myline/panel/Bottommenu.vue'
import Shareurl from '@/shareurl/Shareurl.vue'
import router from '../router'

const queryData = params => {
  return macService.macfind(params.id) 
};


export default {
  name: 'Myapply',
  components: {
    Inforact,
    Shareurl,
    Bottommenu,
  }, 
  props: {
    msg: String
  }, 
  data() {
    return {
      spinnings: true,  
      showTop: false,                
      classtheme:null,
      objs: null,      
      uId:'',
      message:'',
    };
  },  
  mounted(){
        //console.log(this.$route.query.userId);
    this.uId = this.$route.params.id
    this.fetch({id:this.uId});
  },
  methods: {
    query(rs){
      this.classtheme = rs
    },        
    fetch(params = {}) {
      queryData({
        ...params,
      }).then(({ data }) => {
          this.objs = data;
      });
    },
    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },
    showmessage(val){
          this.message = val
          this.showTop = true;          
          let ms =setTimeout(() => {   
              this.showTop = false;
              this.message =''
              clearInterval(ms);
          }, 4000);       
    },
    onHide(evt) {
          if(evt.trigger === "backdrop"){
              evt.preventDefault();
          }
      }, 
    openshare(){
      this.$refs['my-loading'].show()
    },
    loadings(val){
      this.spinnings =val
    },
    
    toNext(){
      //router.replace({ name: 'Myline'})
      router.go(-1)
    },
  },      
}
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.sidenav {
  width: 230px;
  position: fixed;
  z-index: 1;
  top: 130px;
  right: 0;
  overflow-x: hidden;
  padding: 0;
}
.sidenav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 25px;
  color: #2196F3;
  display: block;
}

.sidenav a:hover {
  color: #064579;
}
.linefooter {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   height: 60px;
   background-color: #f0f8f8;
   color: #f0f8f8;
   text-align: center;
   
}
.lineHeader {
   position: fixed;
   left: 0;
   top: 0;
   z-index: 7;
   opacity:1;
   width: 100%;
   height: 2.3rem;
   padding: 0.2rem;
   background-color: #3b1b75;
   color: #f0f8f8;
   text-align: center;
   
}

.fontstyle{
   font-size:0.8rem;

   color:#faf8f8;
}

</style>

